<div class="validation-container">
    <div class="validation-header">
        Validation encountered
        {{hasValidationErrors() ?
    getValidationErrorCount() + " error" + (getValidationErrorCount() > 1 ? "s" : "") : ""}}
        {{hasValidationErrors() && hasValidationWarnings() ? " and " : ""}}
        {{hasValidationWarnings() ?
    getValidationWarningCount() + " warning" + (getValidationWarningCount() > 1 ? "s" : "") : ""}}
    </div>

    <div class="validation-messages">
        @for (errorMessage of getValidationErrors(); track errorMessage) {
            <div class="validation-inline">
                <i class="error nlrp-icon nlrp-icon-error nlrp-18"></i>
                <span>{{errorMessage}}</span>
            </div>
        }

        @for (warningMessage of getValidationWarnings(); track warningMessage) {
            <div class="validation-inline">
                <i class="warning nlrp-icon nlrp-icon-warning nlrp-18"></i>
                <span>{{warningMessage}}</span>
            </div>
        }
    </div>
</div>
